import React, { Component } from 'react';

import { SectionTitle, SectionDescription, BoxContentProduct }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const desc = 'Temos uma linha completa de estruturas metálicas para telecomunicação.';

const products = [
    {col: 'col-12 col-md-3 col-lg-3', img:'torre-metalica', title: 'TORRE METÁLICA', url:'http://www.lojaidealbrasil.com.br/c/torre-para-internet/99684-SIT.html' },
    {col: 'col-12 col-md-3 col-lg-3', img:'mastros', title: 'MASTROS', url: 'http://www.lojaidealbrasil.com.br/c/mastros/99899-SIT.html'},
    {col: 'col-12 col-md-3 col-lg-3', img:'suporte', title: 'SUPORTES PARA ANTENAS', url: 'http://www.lojaidealbrasil.com.br/c/mastros/99899-SIT.html'},
    {col: 'col-12 col-md-3 col-lg-3', img:'radios', title: 'RÁDIOS E SOLUÇÕES', url: '/4rf'}       
];

class Product extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-product-mobile' : 'home-product'} id="products">
                <div className="container">
                    {SectionTitle({section: 'Produtos', subtitle:'CONHEÇA ALGUNS DE', featured: 'NOSSOS PRODUTOS'})}
                    {SectionDescription(desc)}  
                    <div className="row">
                        {products.map((item,key) => { return BoxContentProduct(item,key) } )}
                    </div>                 
                </div>
            </section>
        )
    }
}

export default Product;
